import { render } from "./LocationElement.vue?vue&type=template&id=6829ab20"
import script from "./LocationElement.vue?vue&type=script&lang=js"
export * from "./LocationElement.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kl_keepjoy_work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__